module.exports = __webpack_public_path__ + "static/footer-front-wave-df25b718f9d8295cd4c63b5c84e784ea.svg";